import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AirwaysExpenseService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get Airways Expense.
   * @param airwaysExpenseRequest Airways Expense Request
   */
   getAirwaysExpense(airwaysExpenseRequest: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/airwaysExpense`;
    return this.http.post(url, airwaysExpenseRequest);
  }

  /**
   * Get Airways Expense by Seq No.
   * @param seqNo Seq No
   */
   getAirwaysExpenseDetail(seqNo: any): Promise<any> {
    const url = `${environment.expenseApiUrl}/airwaysExpense/${seqNo}`;
    return this.http.get(url).toPromise();
  }

  /**
   * add Airways Expense
   */
   addAirwaysExpense(saveObj: any): Observable<any>{
    const url = `${environment.expenseApiUrl}/airwaysExpense/add`;
    return this.http.post(url, saveObj);
  }

  /**
   * update Airways Expense
   */
  updateAirwaysExpense(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/airwaysExpense/update`;
    return this.http.put(url, updateObj);
  }

  /**
   * delete Airways Expense
   */
  deleteAirwaysExpense(seqNo: Number): Observable<any>{
    const url = `${environment.expenseApiUrl}/airwaysExpense/delete/${seqNo}`;
    return this.http.delete(url);
  }

  /**
   * import Airways Expense by excel
   * @param file upload file
   * @param createUser create User
   */
  importAirwaysExpenseByExcel(file: any, facility: any, createUser: any): Observable<any>{
    const url = `${environment.expenseApiUrl}/import/airwaysExpenseExcelBy`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('facility', facility);
    formData.append('createUser', createUser);

    let response = this.http.post(url, formData);
    return response;
  }
}
